export const shadows = {
    header: '0px 4px 16px rgba(10, 41, 57, 0.08)',
};
//# sourceMappingURL=shadows.js.map